import { render, staticRenderFns } from "./ExerciciosComplete.vue?vue&type=template&id=39abf596&"
import script from "./ExerciciosComplete.vue?vue&type=script&lang=js&"
export * from "./ExerciciosComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports